module.exports = __webpack_public_path__ + "img/1549635169.2b35926e.jpg";